<template>
    <app-layout title="Boekhouding">
        <template #header>
            <page-title title="Boekhouding" />
        </template>

        <template #pageContent>
            <ul>
                <li>
                    <Link :href="route('accountancy.invoice-customers')">
                        Facturatieklanten
                    </Link>
                </li>
                <li>
                    <Link :href="route('accountancy.post-invoices')">
                        Nafacturatie
                    </Link>
                </li>
                <li>
                    <Link :href="route('accountancy.credit-notes.index')">
                        Creditnota's
                    </Link>
                </li>
                <li>
                    <Link :href="route('accountancy.zero-invoices')">
                        0-facturen
                    </Link>
                </li>
            </ul>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'

import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLayout,
        PageTitle,
        Link
    },
}

</script>
